import { useEffect, useState } from "react";
import { Switch } from "../ui/switch";
import { Power, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const token = () =>
  localStorage.getItem("admin_token") || localStorage.getItem("token");

export function GoogleKillSwitch() {
  const [engaged, setEngaged] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const load = async () => {
    try {
      const r = await fetch(`${API}/api/admin/pipeline/google-kill-switch`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      const d = await r.json();
      setEngaged(!!d.engaged);
    } catch (e) {
      setMsg("status unavailable");
    }
  };

  useEffect(() => {
    load();
  }, []);

  const flip = async (nextEngaged) => {
    setBusy(true);
    setMsg("");
    try {
      const r = await fetch(
        `${API}/api/admin/pipeline/google-kill-switch?engaged=${nextEngaged}`,
        { method: "POST", headers: { Authorization: `Bearer ${token()}` } }
      );
      const d = await r.json();
      if (d.blocked) setMsg(d.reason || "blocked (preview is read-only)");
      else setEngaged(!!d.engaged);
    } catch (e) {
      setMsg("flip failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="px-5 py-3 bg-white border-t border-slate-100 flex items-center justify-between"
      data-testid="google-kill-switch"
    >
      <div className="flex items-center gap-2.5">
        <Power
          className={`w-4 h-4 ${engaged ? "text-red-500" : "text-emerald-500"}`}
        />
        <div>
          <div className="text-sm font-semibold text-slate-800">
            Google Places API calls
          </div>
          <div className="text-[11px] text-slate-500">
            {engaged === null
              ? "checking…"
              : engaged
              ? "HALTED — kill-switch engaged (no calls, $0)"
              : "Live — calls allowed (subject to API gate)"}
            {msg ? ` · ${msg}` : ""}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin text-slate-400" />}
        <span className="text-[11px] font-medium text-slate-400">
          {engaged ? "OFF" : "ON"}
        </span>
        <Switch
          checked={engaged === false}
          disabled={busy || engaged === null}
          onCheckedChange={(on) => flip(!on)}
          data-testid="google-kill-switch-toggle"
        />
      </div>
    </div>
  );
}
